import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import EditPostbackPage from './EditPostbackPage';
import { actions } from './EditPostbackPage.actions';
import {
    getPostback
} from './EditPostbackPage.selectors';

const mapStateToPropsSelectors = createStructuredSelector({
    postback: getPostback
});

const EditPostbackPageComponent = connect(
    function mapStateToProps(state) {
        return {
            ...mapStateToPropsSelectors(state),
            loading: state.postbacks.list.loading
        };
    },
    function mapDispatchToProps(dispatch) {
        return {
            getListPostbacks: actions.getListPostbacks
        };
    }
)(EditPostbackPage);

export default EditPostbackPageComponent;
